export default __webpack_public_path__ + "static/media/placeholder_store01-en-web.57c79a36.png";